import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@components/common/Modal/Modal';
import { useTranslation } from 'next-i18next';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import { LinkStyled } from '@components/common';


/**
 * @description Renders the info modal for account suspended
 * The modal can be opened anywhere in the app using the **showAccountSuspendedModal** function.
 */
export const AccountFirstPaymentModal = NiceModal.create(() => {
  // Use a hook to manage the modal state
  const modal = useModal();

  // Close modal
  const closeModal = () => {
    void modal.hide();
  };

  // Translation
  const { t } = useTranslation('common');

  // Cleanup Redux states and re-fetch after closing the modal depending on the flow step

  // Render component
  // *****************************************
  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      size="lg"
      header={t('global.suspended')}
      body={(
        <div className="flex flex-col items-center justify-center">
          <ExclamationCircleIcon className="mt-5 size-10 fill-warning" />
          <p className="mt-5">{t('unlock.error.payment_required')}</p>

          <LinkStyled
            href="/wallet/orders"
            rounding="full"
            color="warning"
            className="my-5 inline-block w-fit"

          >
            {t('global.transactions')}
          </LinkStyled>

        </div>
)}
    />
  );
});

export const showAccountFirstPaymentModal = () => {
  void NiceModal.show(AccountFirstPaymentModal);
};
